import { render } from "./AdminReports.vue?vue&type=template&id=5f9d1666&scoped=true&ts=true&lang=pug"
import script from "./AdminReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminReports.vue?vue&type=script&lang=ts&setup=true"

import "./AdminReports.vue?vue&type=style&index=0&id=5f9d1666&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9d1666"]])

export default __exports__